import * as TK from 'translations/locales/translation-keys.constant';

export const cateringEventDetailsCommonLocale = {
  [TK.CATERING_EVENT_DETAILS_TITLE]: 'Event Details',
  [TK.CATERING_EVENT_DETAILS_NO_DETAILS_MESSAGE]:
    'No event details were found, please add your information to explore available products.',
  [TK.CATERING_ORDER_TYPE_LABEL]: 'Order Type:',
  [TK.CATERING_SHOW_MORE_PRODUCTS]: 'Load {{product_count}} More',
  [TK.CATERING_ZIP_CODE_LABEL]: 'Zip Code:',
  [TK.CATERING_EVENT_DATE_LABEL]: 'Event Date:',
  [TK.CATERING_PICKUP_STORE_LABEL]: 'Pickup Store:',
  [TK.CATERING_DELIVERY_STORE_LABEL]: 'Delivery Store:',
  [TK.CATERING_DELIVERY]: 'Delivery',
  [TK.CATERING_PICKUP]: 'Pickup',
  [TK.CATERING_ADD_DETAILS]: 'Add Details',
  [TK.CATERING_EDIT_DETAILS]: 'Edit Details',
  [TK.CATERING_SHOWING_RESULTS]: 'Showing {{count}} Results',
  [TK.CATERING_SELECT_PICKUP_STORE]: 'Select local pickup store',
  [TK.CATERING_SELECT_DELIVERY_STORE]: 'Select your delivery store',
  [TK.CATERING_LOADING_STORES]: 'Loading stores...',
  [TK.CATERING_NO_STORES_FOUND]: 'No stores could be loaded for this zip code',
  [TK.CATERING_SELECT_STORE]: 'Select Store',
  [TK.CATERING_LOAD_MORE_STORES]: 'Load {{store_count}} More Stores',
  [TK.CATERING_EVENT_DETAILS_MODAL_TITLE]: 'event details',
  [TK.CATERING_TELL_US_ABOUT_EVENT]: 'Tell us more about your event.',
  [TK.CATERING_WHERE_IS_EVENT]: 'Where is the event?',
  [TK.CATERING_EVENT_DATE_REQUIRED]: 'Event date*',
  [TK.CATERING_SELECT_DATE]: 'Select date',
  [TK.CATERING_SELECT_ORDER_TYPE]: 'Select your Order Type',
  [TK.CATERING_UNAVAILABLE]:
    'Sorry! {{type}} is unavailable for this zip code on this date. Click to see the products that are available for pickup for the selected date.',
  [TK.CATERING_SELECT_A_STORE]: 'Select A Store',
  [TK.CATERING_START_ORDER]: 'Start Order',
  [TK.CATERING_UPDATE_ORDER]: 'Update Order',
  [TK.CATERING_ZIP_CODE_REQUIRED]: 'Zip code is required',
  [TK.CATERING_ORDER_TYPE_REQUIRED]: 'Order type is required',
  [TK.CATERING_ENTER_ZIP_CODE]: 'Enter ZIP Code',
  [TK.CATERING_ENTER_POSTAL_CODE]: 'Enter Postal Code',
  [TK.CATERING_VALID_ZIP_CODE]: 'Please enter a valid 5-digit ZIP code',
  [TK.CATERING_VALID_POSTAL_CODE]: 'Please enter a valid postal code',
  [TK.CATERING_VALID_CANADIAN_POSTAL_CODE]:
    'Please enter a valid Canadian postal code',
  [TK.CATERING_ZIP_NOT_SERVICED]:
    'This zip code is not serviced by Edible, please select another zip code to order.',
  [TK.CATERING_ERROR_GETTING_COORDINATES]:
    'Error getting coordinates for zip code',
  [TK.CATERING_ERROR_LOADING_STORES]: 'Error loading stores',
  [TK.CATERING_NO_STORES_ZIP_CODE]: 'No stores found for zip code {{zipCode}}',
  [TK.CATERING_NO_STORES_AVAILABLE_DATE]:
    'No stores available for the date {{eventDate}}',
  [TK.CATERING_CURBSIDE]: 'Curbside',
  [TK.CATERING_SMOOTHIE]: 'Smoothie',
  [TK.CATERING_DELIVERY_SERVICE]: 'Delivery',
  [TK.CATERING_ADD_TO_CART_BUTTON]: 'Add To Cart',
  [TK.CATERING_MINICART_SUBTOTAL]: 'Subtotal',
  [TK.CATERING_MINICART_SALES_TAX]: 'Sales Tax:',
  [TK.CATERING_MINICART_DELIVERY_FEES]: 'Delivery Fees:',
  [TK.CATERING_MINICART_DELIVERY_FEES_INFO]:
    'Fees and taxes are calculated at checkout.',
  [TK.CATERING_MINICART_REVIEW_CHECKOUT]: 'Review & Checkout',
  [TK.CATERING_MINIMUM_ORDER_WARNING]:
    'A {{amount}} min. subtotal is required for checkout',
  [TK.CATERING_MINICART_FREE]: 'FREE',
  [TK.CATERING_MINICART_DELIVERY_UNLOCKED]: 'delivery unlocked!',
  [TK.CATERING_CONTACT_DETAILS]:
    'We only contact the recipient if there are delivery complications',
};
